import React, { useEffect, useState } from 'react';
import axios from "../axiosConfig";
import InteractionsTable from '../components/InteractionsTable';
import PageTitle from "../components/PageTitle";

const Interactions = () => {
  //const [interactions, setInteractions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Get current user from localStorage
  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch {
      return null;
    }
  })();

  const defaultParticipants = [{
    id: user.user_contact_id,
    type: "contact",
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    is_sender: false,
  }];

  return (
    <div className="page-layout">
      <PageTitle>All Interactions</PageTitle>
      
      <div className="page-content">
        <InteractionsTable 
          defaultParticipants={defaultParticipants} 
          onTaskCreated={() => {}} 
          fillPage
        />
      </div>
    </div>
  );
};

export default Interactions;
